export default __webpack_public_path__ + "static/media/bookstore.cef62caa.png";